import React, { useEffect, useState } from "react";
import { DebounceInput } from "react-debounce-input";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import { PGET, GET, DOWNLOAD, excelParams } from "../../../api/adminApi";
import { CustomSvg } from "../../../utils/CustomSvg";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";
import { formatNumber } from "../../../utils/utilities";
import ChangeBalance from "./modal/ChangeBalance";
import { FiEdit } from "react-icons/fi";

function MastersReport() {
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [value, setValue] = useState("");
  const [currentPage, setCurrentPage] = useState(
    +localStorage.getItem("currentPageMasters") || 0,
  );

  const [regions, setRegions] = useState([{ id: 0, name: "Все регионы" }]);
  const [region, setRegion] = useState(regions[0]);

  const [statuses, setStatuses] = useState([
    { id: 0, name: "Все статусы" },
    { id: 1, name: "Не регистр." },
    { id: 2, name: "Регстрирован" },
  ]);
  const [status, setStatus] = useState(statuses[0]);

  // Points Type Filter State (Values are exactly 1 and 2)
  const [pointsTypes] = useState([
    { id: 1, name: "Отчет по текущим баллам" },
    { id: 2, name: "Отчет по периоду" },
  ]);
  const [pointsType, setPointsType] = useState(pointsTypes[0]);

  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;

  const [modal, setModal] = useState({
    show: false,
    data: null,
  });

  const selectRegion = (selectedOpt) => {
    if (region !== selectedOpt) {
      setRegion(selectedOpt);
      setCurrentPageToZero();
    }
  };

  const selectStatus = (selectedOpt) => {
    if (status !== selectedOpt) {
      setStatus(selectedOpt);
      setCurrentPageToZero();
    }
  };

  const selectPointsType = (selectedOpt) => {
    if (pointsType !== selectedOpt) {
      setPointsType(selectedOpt);
      setCurrentPageToZero();
    }
  };

  const handleSearchInput = (e) => {
    setValue(e.target.value);
    setCurrentPageToZero();
  };

  function setCurrentPageToZero() {
    setCurrentPage(0);
    localStorage.setItem("currentPageMasters", 0);
  }

  const paginate = (data) => {
    setCurrentPage(data.selected);
    localStorage.setItem("currentPageMasters", data.selected);
  };

  async function getRegions() {
    const response = await GET("/services/admin/api/region-helper/1");
    if (response.length > 0) {
      setRegions([regions[0], ...response]);
    }
  }

  async function getItems() {
    if (startDate && endDate) {
      const data = await PGET(
        "/services/admin/api/master-report-pageList",
        true,
        {
          region: region.id,
          page: currentPage,
          size: 10,
          search: value,
          dateFrom: moment(startDate).format("YYYY-MM-DD"),
          dateTo: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
          activated: status.id,
          pointsType: pointsType.id,
        },
      );
      setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
      setItems(data.data);
    }
  }

  function weekOwnerAgents() {
    const excelUrl =
      "https://api-club.akfacomfort.uz/services/admin/api/masters-report/download-all";
    const fileName = "reportall.xlsx";
    excelParams(excelUrl, fileName, true, {
      region: region.id,
      size: 10,
      search: value,
      dateFrom: moment(startDate).format("YYYY-MM-DD"),
      dateTo: moment(endDate).add(1, "day").format("YYYY-MM-DD"),
      activated: status.id,
      pointsType: pointsType.id,
    });
  }

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    region,
    currentPage,
    value,
    dateRange,
    startDate,
    endDate,
    status,
    pointsType,
  ]);

  useEffect(() => {
    getRegions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className="br-5 card"
      style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
    >
      <div className="pt-5 border-0 card-header">
        <h3
          className="card-title align-items-start flex-column"
          style={{ marginLeft: -15 }}
        >
          <span className="mb-1 card-label fw-bold fs-3">
            Отчет по баллам продавцов
          </span>
        </h3>
      </div>

      <div className="px-3 pt-2 pb-4">
        <div className="mb-4 d-flex justify-content-end">
          <div className="gap-4 d-flex">
            <div style={{ width: "240px" }}>
              <Select
                value={pointsType}
                placeholder="Тип отчета"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                options={pointsTypes}
                onChange={selectPointsType}
              />
            </div>

            <div
              style={{
                width: 200,
                opacity: pointsType.id === 1 ? 0.5 : 1,
                pointerEvents: pointsType.id === 1 ? "none" : "auto",
                transition: "opacity 0.2s ease-in-out",
              }}
            >
              <CustomDatePicker
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  setDateRange(update);
                }}
                className="datepicker-custom-input"
                disabled={pointsType.id === 1}
              />
            </div>
            <div style={{ width: "150px" }}>
              <Select
                value={status}
                placeholder="Выберите статус"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                options={statuses}
                onChange={selectStatus}
              />
            </div>
            <div style={{ width: "150px" }}>
              <Select
                value={region}
                placeholder="Выберите регион"
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                options={regions}
                onChange={selectRegion}
              />
            </div>

            <div className="position-relative">
              <DebounceInput
                minLength={3}
                debounceTimeout={400}
                value={value}
                onChange={handleSearchInput}
                type="text"
                className="input-search search-icon br-5"
                size={24}
                placeholder="Поиск"
              />
            </div>

            {/* Added gap-2 here to separate the two buttons nicely */}
            <div className="gap-2 d-flex">
              <button
                onClick={weekOwnerAgents}
                className="mr-0 box-shadow"
                style={{
                  backgroundColor: "#fcfcfc",
                  height: 38,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(212, 211, 214)",
                  borderRadius: 5,
                  padding: "0 10px",
                }}
              >
                <CustomSvg
                  path="/icons/duotune/files/fil017.svg"
                  className="mr-2 svg-icon-3"
                />
                Скачать все
              </button>
            </div>
          </div>
        </div>

        <div style={{ overflow: "auto", maxHeight: "75vh" }}>
          <table className="table p-0 bg-white border table-rounded gy-4 gs-7">
            <thead className="top-0 rounded position-sticky">
              <tr className="text-gray-800 border-gray-200 fw-bold fs-6 border-bottom-2">
                <th
                  className="text-center text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    width: "30px",
                    borderTopLeftRadius: "8px",
                  }}
                >
                  №
                </th>
                <th
                  className="text-white text-start"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Продавец
                </th>
                <th
                  className="text-white text-start"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Регион
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Панельный
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Секционный
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Котел
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  По рефералу
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Текущий балл
                </th>
                <th
                  className="text-center text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                  }}
                >
                  Общие баллы
                </th>
                <th
                  className="text-center text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopRightRadius: "8px",
                  }}
                ></th>
              </tr>
            </thead>

            <tbody style={{ overflowX: "auto" }}>
              {items.map((item, index) => {
                return (
                  <tr key={item.id} className="borderBottom">
                    <td className="text-center">
                      {currentPage === 0
                        ? index + 1
                        : currentPage * 10 + index + 1}
                    </td>
                    <td className="text-start">
                      <div className="flex flex-col">
                        <div className="flex">
                          <p className="m-0 p-0 font-bold text-#eff2f5">
                            ФИО:{" "}
                          </p>
                          <p className="p-0 mb-0 ml-2">{item.name}</p>
                        </div>
                        <div className="flex">
                          <p className="m-0 p-0 font-bold text-#eff2f5">
                            Номер:{" "}
                          </p>
                          <p className="p-0 mb-0 ml-2">{item.phone}</p>
                        </div>
                      </div>
                    </td>
                    <td className="text-start">{item.regionName}</td>
                    <td className="text-center">
                      {formatNumber(item.totalPointPanel)}
                    </td>
                    <td className="text-center">
                      {formatNumber(item.totalPointSection)}
                    </td>
                    <td className="text-center">
                      {formatNumber(item.totalPointKotel)}
                    </td>
                    <td className="text-center">
                      {formatNumber(item.totalPointReferal)}
                    </td>
                    <td className="text-center">
                      {formatNumber(item.totalPoint)}
                    </td>
                    <td className="text-center">
                      {formatNumber(item.totalPointOverall)}
                    </td>
                    <td className="text-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setModal({ show: true, data: item });
                        }}
                        className="flex flex-row justify-center items-center bg-amber-50 rounded-full border"
                        style={{ borderRadius: 100, height: 40, width: 40 }}
                      >
                        <FiEdit color={"#5C3EBA"} size={16} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {pageCount > 1 && (
          <ReactPaginate
            forcePage={currentPage}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={paginate}
            containerClassName={"pagination"}
            activeClassName={"active"}
            pageClassName={"page-item box-shadow br-5"}
          />
        )}
      </div>
      {modal.data && (
        <ChangeBalance modal={modal} setModal={setModal} getItems={getItems} />
      )}
    </div>
  );
}

export default MastersReport;
